import { Grid } from "@material-ui/core";
import { useEffect, useState } from "react";
import { Bar, Line } from "react-chartjs-2";
import { Button, SelectBox, SVG, Text } from "sunrise-ui";
import FilterComponent from "../../components/helperComponents/FilterComponent";
import "./Reports.scss";
import {
  Chart as ChartJS,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  PointElement,
  LineElement,
  LineController,
} from "chart.js";
import {
  CHART_COLORS,
  customTooltip,
} from "../../constants/reactChartConstants";
import { useSelector } from "react-redux";
import { getAllProjectData } from "../../redux/reducers/projectReducers";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../redux/store";
import { getRank, getUsersByTypeAndProject } from "../../redux/reducers/users";
import { displayDate } from "../../utilities/displayDateUtils";
import toaster from "../../utilities/toaster";
import Loader from "../../utilities/Loader";
import {
  getEngProdMonthly,
  getMultipleEngEffcy,
  getSingleEngEffcy,
} from "../../redux/reducers/reportReducer";
import SelectOptionMsg from "../../utilities/SelectOptionMsg";
import MultipleSelect from "../../utilities/MultipleSelect/MultipleSelect";
ChartJS.register(
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  PointElement,
  LineElement,
  LineController
);
const initialLineData = {
  labels: [],
  datasets: [
    {
      label: "Efficiency",
      data: [],
    }
  ],
};
const initialBarData = {
  labels: [],
  datasets: [
    {
      label: "Efficiency",
      data: [],
      hoverBackgroundColor: [],
    },
  ],
}
const EngineerProductivity = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [project, setPtoject] = useState("");
  const [filterDateSingleEngineer, setfilterDateSingleEngineer] = useState<any>(
    {
      from: "",
      to: "",
    }
  );
  const [engineerDetails, setEngineerDetails] = useState({
    name: "",
    empId: "",
    workingSince: "",
  });
  const [multipleValue, setMultipleValue] = useState([]);
  const [filterDateMultipleEngineer, setfilterDateMultipleEngineer] =
    useState<any>({
      from: "",
      to: "",
    });
  const [loading, setLoading] = useState({ single: false, multi: false });

  const allProject = useSelector((state: any) => state.PROJECT.allProjectData);
  const engineersList = useSelector(
    (state: any) => state.USERS.userByTypeAndProject
  );
  const {
    singleEngineerEfficiiency,
    multipleEngineerEfficiiency,
    productivityOfEngineerMonthly,
  } = useSelector((state: any) => state.REPORT);
  const ranks = useSelector((state: any) => state.USERS.ranks);
  useEffect(()=>{
    dispatch(getRank({ endPoint: "general/get-ranks" }));
  },[dispatch])
  const [lineGraphData, setLineGraphData] = useState(initialLineData);
  const [barGraphData, setBarGraphData] = useState(initialBarData);

  // Monthly Efficiency
  useEffect(()=>{
    const lineData = {
      labels: productivityOfEngineerMonthly?.monthWiseReport
        ? productivityOfEngineerMonthly?.monthWiseReport?.map(
            (val: any) => val.month
          )
        : ["Jan", "Feb", "Mar", "Apr", "May", "Jun"],
      datasets: [
        {
          label: "Efficiency",
          data: productivityOfEngineerMonthly?.monthWiseReport
            ? productivityOfEngineerMonthly?.monthWiseReport?.map(
                (val: any) => val.efficiency
              )
            : [0, 0, 0, 0, 0, 0, 70, 80, 90, 100],
          fill: false,
          borderColor: CHART_COLORS.BLUE,
          tension: 0.1,
          pointStyle: "circle",
          pointRadius: 5,
          pointHoverRadius: 8,
        },
      ],
    };
    setLineGraphData(lineData);
  },[productivityOfEngineerMonthly?.monthWiseReport]);

  const monthlyEfficiencyLineOptions = {
    plugins: {
      tooltip: customTooltip,
      legend: {
        display: false,
      },
    },
    scales: {
      y: {
        title: {
          display: true,
          text: "Efficiency (%)",
          font: { weight: "bold" },
        },
      },
      x: {
        title: {
          display: true,
          text: "Time (Months)",
          font: { weight: "bold" },
        },
      },
    },
  };

  // Stepwise report
  //-------bar chart data------------
  const barChartData = {
    labels: productivityOfEngineerMonthly?.stepByReport
      ? productivityOfEngineerMonthly?.stepByReport?.map(
          (val: any) => val.stepShortName
        )
      : [],
    datasets: [
      {
        label: "Actual Avg. Duration for Step Completion",
        data: productivityOfEngineerMonthly?.stepByReport
          ? productivityOfEngineerMonthly?.stepByReport?.map(
              (val: any) => val.actualTime
            )
          : [],
        backgroundColor: productivityOfEngineerMonthly?.stepByReport
          ? productivityOfEngineerMonthly?.stepByReport?.map(
              (val: any) => CHART_COLORS.BLUE
            )
          : [],
        hoverBackgroundColor: productivityOfEngineerMonthly?.stepByReport
          ? productivityOfEngineerMonthly?.stepByReport?.map(
              (val: any) => CHART_COLORS.SELECTED_BLUE
            )
          : [],
      },
      {
        label: "Std. Duration for Step Completion",
        data: productivityOfEngineerMonthly?.stepByReport
          ? productivityOfEngineerMonthly?.stepByReport?.map(
              (val: any) => val.idealTime
            )
          : [],
        backgroundColor: productivityOfEngineerMonthly?.stepByReport
          ? productivityOfEngineerMonthly?.stepByReport?.map(
              (val: any) => CHART_COLORS.YELLOW
            )
          : [],
        hoverBackgroundColor: productivityOfEngineerMonthly?.stepByReport
          ? productivityOfEngineerMonthly?.stepByReport?.map(
              (val: any) => CHART_COLORS.SELECTED_YELLOW
            )
          : [],
      },
    ],
  };

  const singleEngineerEfficiencyOptions: any = {
    plugins: {
      tooltip: customTooltip,
    },
    maintainAspectRatio: false,
    scales: {
      y: {
        title: { display: true, text: "Time (Hrs)", font: { weight: "bold" } },
        base: 0,
      },
      x: { title: { display: true, text: "Steps", font: { weight: "bold" } } },
    },
  };

  // Multiple Engineers Report
  useEffect(()=>{
    const barChartData2 = {
      labels: multipleEngineerEfficiiency.map(
        (val: any) =>
          engineersList.find((eng: any) => eng._id === val.engId)?.name
      ),
      datasets: [
        {
          label: "Efficiency",
          data: multipleEngineerEfficiiency.map((val: any) => val.data),
          backgroundColor: multipleEngineerEfficiiency.map(
            (val: any) => CHART_COLORS.BLUE
          ),
          hoverBackgroundColor: multipleEngineerEfficiiency.map(
            (val: any) => CHART_COLORS.SELECTED_BLUE
          ),
        },
      ],
    };
    setBarGraphData(barChartData2);
  },[engineersList, multipleEngineerEfficiiency])


  const multipleEngineerEfficiencyOptions: any = {
    indexAxis: "y",
    plugins: {
      tooltip: customTooltip,
      legend: {
        display: false,
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: "Efficiency (%)",
          font: { weight: "bold" },
        },
      },
      y: {
        title: { display: true, text: "Engineers", font: { weight: "bold" } },
        grid: { display: false, padding: 5 },
      },
    },
  };

  const updateProjectId = (name: string) => {
    const projectId = allProject.find((val: any) => val.projectName === name);
    setPtoject(projectId?._id);
    dispatch(
      getUsersByTypeAndProject({
        endPoint: `general/get-users-by-project-and-role?projectId=${projectId?._id}&role=engineer`,
      })
    );
  };

  const resetSingleEng = () => {
    setfilterDateSingleEngineer({
      from: "",
      to: "",
    });
  };
  const resetMultipleEng = () => {
    setfilterDateMultipleEngineer({
      from: "",
      to: "",
    });
  };

  const handleSingleEngineerDetails = () => {
    setLineGraphData(initialLineData);
    if (engineerDetails.name !== "" && project !== "") {
      const id = engineersList.find(
        (val: any) => val.name === engineerDetails.name
      );
      // to get monthly and step wise report of an engineer
      const data = {
        id: id?._id,
        projectId: project,
        dates: {
          fromDate: filterDateSingleEngineer.from,
          toDate: filterDateSingleEngineer.to,
        },
      };

      setLoading((state: any) => ({ ...state, single: true }));
      dispatch(
        getEngProdMonthly({
          endPoint: `reports/individial_engineer_efficiency`,
          data: data,
        })
      ).then(() => setLoading((state: any) => ({ ...state, single: false })));

      // to get efficiency of an engineer
      dispatch(
        getSingleEngEffcy({
          endPoint: `reports/multiple_engineers_efficiency`,
          data: {
            ...data,
            ids: [data.id],
          },
        })
      );
    } else {
      if (project === "") {
        toaster("error", "Please select project");
      }
      if (engineerDetails.name === "") {
        toaster("error", "Please select engineer");
      }
    }
  };

  const handlefilterDate = ()=>{};

  const handleMultipleEngineerDetails = () => {
    if (multipleValue.length > 0 && project !== "") {
      const ids = multipleValue.map(
        (val: any) => engineersList.find((eng: any) => eng.name === val)?._id
      );
      const data = {
        ids,
        projectId: project,
        dates: {
          fromDate: filterDateMultipleEngineer.from,
          toDate: filterDateMultipleEngineer.to,
        },
      };
      setLoading((state: any) => ({ ...state, multi: true }));
      dispatch(
        getMultipleEngEffcy({
          endPoint: `reports/multiple_engineers_efficiency`,
          data: data,
        })
      ).then(() => setLoading((state: any) => ({ ...state, multi: false })));
    } else {
      if (project === "") {
        toaster("error", "Please select project");
      }
      if (multipleValue.length === 0) {
        toaster("error", "Please select atleast one engineer");
      }
    }
  };

  useEffect(() => {
    dispatch(
      getAllProjectData({
        endPoint: `project/get-all-projects`,
      })
    );
  }, [dispatch]);

  return (
    <Grid container className="bg--white box--shadow mt0 p1">
      <Grid className="standared_width">
        <Text type="normal" fonts="normal" fontSize={18} className="mb0 mt0">
          <span className="fw500">Select Project</span>
        </Text>
        <SelectBox
          data={allProject?.map((val: any) => val?.projectName)}
          placeHolder="Select Project"
          borderColor={"primary"}
          onChange={(e: any) => {
            updateProjectId(e.target.value);
            setLineGraphData(initialLineData);
            setBarGraphData(initialBarData);
            resetSingleEng();
            resetMultipleEng();
          }}
        />
      </Grid>
      <Grid container className="bg--white box--shadow mt1 p1">
        <Grid item xs={12} container spacing={2}>
          <Grid item xs={12}>
            <Text
              type="normal"
              fonts="normal"
              fontSize={18}
              className="mb0 mt0"
            >
              <span className="fw500">Productivity of Single Engineer</span>
            </Text>
          </Grid>
        </Grid>
        <Grid item xs={12} container spacing={2}>
          <Grid item xs={3}>
            <Text
              type="normal"
              fonts="normal"
              fontSize={16}
              className="mb0 mt1"
            >
              <span className="fw500">Select Engineer</span>
            </Text>
            <SelectBox
              data={engineersList?.map((val: any) => val.name)}
              placeHolder="Select Engineer"
              borderColor={"primary"}
              onChange={(e: any) => {
                setLineGraphData(initialLineData);
                const eng = engineersList.find(
                  (val: any) => val.name === e.target.value
                );
                setEngineerDetails({
                  name: eng?.name,
                  empId: eng?.empId,
                  workingSince: eng?.currentProject?.fromDate,
                });
                resetSingleEng();
              }}
            />
          </Grid>
          <Grid item className={"mt2"} direction="row" alignItems="center">
            <div className="filter_box filter_margin">
              <FilterComponent
                handleFilterDate={handlefilterDate}
                setValue={setfilterDateSingleEngineer}
                value={filterDateSingleEngineer}
                resetAll={resetSingleEng}
              />
            </div>
          </Grid>
          <Grid item className="mt2">
            <Button
              type="button"
              size="medium"
              isRounded={true}
              category="primary"
              onClick={() => {handleSingleEngineerDetails()}}
              className="submit_button mb1 mt3 mr-1 pl pr f14"
            >
              <SVG type={"searchIcon"} />
              Search
            </Button>
          </Grid>
        </Grid>
        <Grid container xs={12} spacing={2}>
          <Grid item xs={6}>
            <Grid item xs={12}>
              <Text
                type="normal"
                fonts="normal"
                fontSize={18}
                className="mb0 mt0"
              >
                <span className="fw500">Monthly Efficiency of Engineer(%)</span>
              </Text>
            </Grid>
            <Grid item xs={12}>
              {loading.single ? (
                <Loader
                  color="#5f67e0"
                  loading={loading.single}
                  size={14}
                  height="25vh"
                />
              ) : singleEngineerEfficiiency === "" ? (
                <SelectOptionMsg text="Please choose project and engineer" />
              ) : (
                <Line data={lineGraphData} options={monthlyEfficiencyLineOptions} />
              )}
            </Grid>
          </Grid>
          <Grid item xs={1}></Grid>
          <Grid item xs={5}>
            <Grid item xs={8}>
              <Grid>
                <Text
                  type="normal"
                  fonts="normal"
                  fontSize={18}
                  className="mb1 mt0 fw500"
                >
                  Engineer Details
                </Text>
                <Text
                  type="normal"
                  fonts="normal"
                  fontSize={16}
                  className="mb1_5 mt0"
                >
                  <Grid className="d-flex v-center w100">
                    <Grid className="icon_container mr">
                      <SVG type={"engineer"} />
                    </Grid>
                    <Grid className="w100">
                      <span className="fw500">{engineerDetails?.name}</span>
                    </Grid>
                  </Grid>
                </Text>
                <Text
                  type="normal"
                  fonts="normal"
                  fontSize={16}
                  className="mb1_5 mt0"
                >
                  <Grid className="d-flex v-center w100">
                    <Grid className="icon_container mr">
                      <SVG type={"globalRank"} />
                    </Grid>
                    <Grid className="w100">
                      <span className="fw500">Current Global Rank:{" "}
                      {ranks &&
                      ranks?.globalranks &&
                      ranks?.globalranks?.filter(
                        (item: any) => item?.empId === engineerDetails?.empId
                      )[0]?.rank
                        ? ranks?.globalranks?.filter(
                            (item: any) => item?.empId === engineerDetails?.empId
                          )[0]?.rank
                        : "NA"}
                        </span>
                    </Grid>
                  </Grid>
                </Text>
                <Text
                  type="normal"
                  fonts="normal"
                  fontSize={16}
                  className="mb1_5 mt0"
                >
                  <Grid className="d-flex v-center w100">
                    <Grid className="icon_container mr">
                      <SVG type={"projectRank"} />
                    </Grid>
                    <Grid className="w100">
                      <span className="fw500">Current Project Rank: {ranks &&
                      ranks?.projectranks &&
                      ranks?.projectranks[
                        allProject &&
                          allProject.filter(
                            (item: any) => item?._id === project
                          )[0]?._id
                      ]?.filter((item: any) => item.empId === engineerDetails?.empId)[0]
                        ?.rank
                        ? ranks?.projectranks[
                            allProject &&
                              allProject.filter(
                                (item: any) => item?._id === project
                              )[0]?._id
                          ]?.filter((item: any) => item.empId === engineerDetails?.empId)[0]
                            ?.rank
                        : "NA"}{" "}</span>
                    </Grid>
                  </Grid>
                </Text>
                <Text
                  type="normal"
                  fonts="normal"
                  fontSize={16}
                  className="mb1_5 mt0"
                >
                  <Grid className="d-flex v-center w100">
                    <Grid className="icon_container mr">
                      <SVG type={"workInProject"} />
                    </Grid>
                    <Grid className="w100">
                      <span className="fw500">
                        Working in Project Since{" "}
                        {displayDate(engineerDetails.workingSince)}
                      </span>
                    </Grid>
                  </Grid>
                </Text>
                <Text
                  type="normal"
                  fonts="normal"
                  fontSize={16}
                  className="mb0 mt0"
                >
                  <Grid className="d-flex v-center w100">
                    <Grid className="icon_container mr">
                      <SVG type={"efficiency"} />
                    </Grid>
                    <Grid className="w100">
                      <span className="fw500">
                        Current Efficiency: {singleEngineerEfficiiency[0]?.data}
                        %
                      </span>
                    </Grid>
                  </Grid>
                </Text>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} container spacing={2}>
          <Grid item xs={12}>
            <Text
              type="normal"
              fonts="normal"
              fontSize={18}
              className="mb0 mt1"
            >
              <span className="fw500">
                Productivity of Single Engineer on Step Basis
              </span>
            </Text>
          </Grid>
        </Grid>
        <Grid item xs={12} container spacing={2}>
          <Grid item xs={12}>
            <Text
              type="normal"
              fonts="normal"
              fontSize={18}
              className="mb0 mt1"
            >
              <span className="fw500">
                Efficiency of Single Engineer on Step Basis(%)
              </span>
            </Text>
          </Grid>
          <Grid item xs={6}>
            {loading.single ? (
              <Loader
                color="#5f67e0"
                loading={loading.single}
                size={14}
                height="25vh"
              />
            ) : singleEngineerEfficiiency === "" ? (
              <SelectOptionMsg text="Please choose project and engineer" />
            ) : (
              <Bar
                data={barChartData}
                options={singleEngineerEfficiencyOptions}
              />
            )}
          </Grid>
          <Grid item xs={1}></Grid>
          <Grid item xs={4}>
            <Grid item xs={12}>
              <Text
                type="normal"
                fonts="normal"
                fontSize={18}
                className="mb1 mt0 fw500"
              >
                Step Details
              </Text>
              {productivityOfEngineerMonthly?.stepByReport &&
                productivityOfEngineerMonthly?.stepByReport?.map((val: any) => (
                  <Text
                    type="normal"
                    fonts="normal"
                    fontSize={16}
                    className="mb1 mt0 fw400"
                  >
                    <span className="fw500">{val.stepShortName}:</span>{" "}
                    {val.stepName}
                  </Text>
                ))}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid container className="bg--white box--shadow mt1 p1">
        <Grid item xs={12} container spacing={2}>
          <Grid item xs={12}>
            <Text
              type="normal"
              fonts="normal"
              fontSize={18}
              className="mb0 mt0"
            >
              <span className="fw500">Productivity of Engineers</span>
            </Text>
          </Grid>
        </Grid>
        <Grid xs={12} container>
          <Grid xs={12} item>
            <Text type="normal" fonts="normal" fontSize={16} className="mb mt1">
              <span className="fw500">Select Engineers (max 8)</span>
            </Text>
          </Grid>
          <Grid xs={5} item>
            <MultipleSelect
              selectData={{
                data: engineersList?.map((val: any) => val.name),
                name: "multiSelect",
                disabled: false,
                placeHolder: "Choose Engineers",
                value: multipleValue,
                borderColor: "primary",
                defaultValue: multipleValue,
                oldValue: multipleValue,
                onChange: (e: any) => {
                  setBarGraphData(initialBarData);
                  if (e.target.value.length < 9) {
                    setMultipleValue(e.target.value);
                  }
                },
              }}
            ></MultipleSelect>
          </Grid>
          <Grid item className={"ml-1"} direction="row" alignItems="center">
            <div className="filter_box_ml">
              <FilterComponent
                handleFilterDate={handlefilterDate}
                setValue={setfilterDateMultipleEngineer}
                value={filterDateMultipleEngineer}
                resetAll={resetMultipleEng}
              />
            </div>
          </Grid>
          <Grid item className="mt2 ml-1">
            <Button
              type="button"
              size="medium"
              isRounded={true}
              category="primary"
              onClick={() => {handleMultipleEngineerDetails()}}
              className="submit_button mb1 mr-1 pl pr f14"
            >
              <SVG type={"searchIcon"} />
              Search
            </Button>
          </Grid>
        </Grid>
        <Grid item xs={6}>
          {loading.multi ? (
            <Loader
              color="#5f67e0"
              loading={loading.multi}
              size={12}
              height="25vh"
            />
          ) : multipleEngineerEfficiiency.length ? (
            <Bar
              data={barGraphData}
              options={multipleEngineerEfficiencyOptions}
            />
          ) : (
            <SelectOptionMsg text="Please select project and engineer" />
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default EngineerProductivity;
